import { createSlice } from '@reduxjs/toolkit'

const viewSlice = createSlice({
    name: 'data/view',
    initialState: {
        view: 'grid',
        query: {
            order: 'asc',
            search: ''
        },
        newProjectDialog: false
    },
    reducers: {
        toggleView: (state, action) => {
            state.view = action.payload
        },
        toggleSort: (state, action) => {
            state.query.order = action.payload
        },
        setSearch: (state, action) => {
            state.query.search = action.payload
        },
        toggleNewProjectDialog: (state, action) => {
            state.newProjectDialog = action.payload
        }
    },
})

export const { toggleView, toggleSort, toggleNewProjectDialog, setSearch } = viewSlice.actions

export default viewSlice.reducer
